/* RESPONSIBLE TEAM: team-reporting */
import { inject as service } from '@ember/service';
import Helper from '@ember/component/helper';
import type DatasetExportScheduleService from 'embercom/services/dataset-export-schedule-service';
import type ScheduledExternalShare from 'embercom/models/reporting/scheduled-external-share';

export default class FormatScheduleFrequencyHelper extends Helper<{
  Args: {
    Positional: [ScheduledExternalShare];
  };
  Return: string;
}> {
  @service declare datasetExportScheduleService: DatasetExportScheduleService;

  compute([schedule]: [ScheduledExternalShare]): string {
    if (!schedule?.exportRule) {
      return '';
    }

    try {
      return this.datasetExportScheduleService.customLabel(schedule);
    } catch (error) {
      return schedule.exportRule.interval?.step || '';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'format-schedule-frequency': typeof FormatScheduleFrequencyHelper;
  }
}
